module.exports = __webpack_public_path__ + "static/2-7122f1e79cc819c54f4e59e801f5980f.jpg";